import { ResultFunc } from 'rxjs/observable/GenerateObservable';
import { 
    PLATFORM_ID,
    Component,
     Inject,
     OnInit,
     OnDestroy,
     Input,
     ChangeDetectionStrategy,
     ChangeDetectorRef,
     AfterViewChecked,
     QueryList,
     ViewChild,
     AfterViewInit,
     HostListener,
     ElementRef
 } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Subject } from 'rxjs/Subject';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { MetaService } from 'angular-engine/engine/service/meta/meta.service';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
    selector: "search",
    templateUrl: "search.template.html",
    styleUrls: ['search.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class Search{
    constructor (
        @Inject(PLATFORM_ID) platformId: string,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        private cd :ChangeDetectorRef,
        private coreEffects: CoreEffects,
        private metaService: MetaService,
        private interactions: EventInteraction,
        private route: ActivatedRoute
    ){
        this.isServer = isPlatformServer(platformId); 
    }
    private isServer = false;
    private subscription: Subscription;
    protected isNotPhone: boolean = false;
    private terms: Subject<string> = new Subject<string>();
    private slides: Observable<Array<any>>;
    private title: String;
    private qSearchTerm = "";
    
    @Input() results:Observable<any>;
    @Input() tagresults : any;
    @Input() showAll : boolean = true;
    @Input() filters : any = {};
    @Input() content : any;
    @Input() meta : any;
    @Input() tags : boolean;
    @Input() hasMoreData : boolean;
    @Input() searchType : string = "SEARCH";
    
    @ViewChild('searchfield') searchField;
    
    ngAfterViewInit(){

        if(!this.isServer){
            let search = this;
            setTimeout( function(){
                if (search.searchField){
                    search.searchField.nativeElement.focus();
                    search.searchField.nativeElement.classList.add('ready'); 
                }
            }, 300);
        }
    }
    
    private termOrTitle():string{
        if(this.results && this.results['value']['meta']){
            if ( this.results['value']['meta'].search_term){
                return this.results['value']['meta'].search_term;
            }
            else{
                return this.results['value']['meta'].title;
            }
        }
    }

    private handleChecked(checked, title){
        let replaceIndexes = [];
        this.results['value']['rows'].forEach(function(row){
            const section = row.meta.title.toLowerCase();
            if (checked){
                if (Object.keys(this.filters).length == 1){
                    if(!this.filters[row.meta.title]){
                        this.coreEffects.storeSearchSectionFirstRowOnHide(section, this.termOrTitle().toLowerCase());
                    }
                }
                else{
                    if(title != row.meta.title){
                        const storeRowData  = this.coreEffects.getSearchSectionFirstRowOnShow(section, this.termOrTitle().toLowerCase());
                        const existingIndex = this.results['value']['rows'].findIndex(resultRow => resultRow.meta.title == row.title , this);
                        if (existingIndex >= 0 && storeRowData){
                            replaceIndexes.push({ idx: existingIndex, data: storeRowData });
                        }
                    }
                }
            }
            else{
                if (Object.keys(this.filters).length == 0){
                    if(title != row.meta.title){
                        const storeRowData  = this.coreEffects.getSearchSectionFirstRowOnShow(section, this.termOrTitle().toLowerCase());
                        const existingIndex = this.results['value']['rows'].findIndex(resultRow => resultRow.meta.title == row.meta.title , this);
                        if (existingIndex >= 0 && storeRowData){
                            replaceIndexes.push({ idx: existingIndex, data: storeRowData });
                        }
                    }
                }
                else{
                    if (title == row.meta.title){
                        this.coreEffects.storeSearchSectionFirstRowOnHide(section, this.termOrTitle().toLowerCase());
                    }
                }
            }
        },this);
        for (let replaceIndex of replaceIndexes){
            this.results['value']['rows'][replaceIndex.idx] =  replaceIndex.data;       
        }
    }
    
    private titleCase(str) {
        return str.toLowerCase().split(' ').map(function(word) {
            return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
    }
    private fireScroll(){
         window.dispatchEvent(new Event('scroll'));
    }

    submit(){
        let aE:any = document.activeElement;
        aE.blur();
        return false;
    }

    ngOnInit(){
        this.isNotPhone = !this.deviceInfo.isPhone;
        this.terms 
        .debounceTime(500)
        .distinctUntilChanged()
        .switchMap(term => {
            this.qSearchTerm = term;
            return (term) ? this.coreEffects.searchByTerm(term.toLowerCase(),true) : Observable.of<any>([])
        })
        .catch(error => {
            return Observable.of<any>([]);
          }
        ).subscribe(res => {
            this.results = Observable.of( res );
            const sTerm = (res['meta'] && res['meta']['title']) ? " - " + res['meta']['title'] : "";
            this.title = this.titleCase("Search" + sTerm);
            this.metaService.setDynamicSearchTitle(this.title, "Search");
            this.cd.detectChanges();
        });

        this.subscription = this.interactions.subscribe( e => {
            if(e.key == "filterSelected"){
                let checked = e.message.event.target.checked;
                if( checked ){
                    this.filters[e.message.title] = checked;
                }
                else{
                    delete this.filters[e.message.title];
                }

                if(Object.keys(this.filters).length == 0){
                    this.showAll = true;
                }else{
                    this.showAll = false;
                }
                //this.handleChecked(checked, e.message.title);
                this.cd.detectChanges();
                this.fireScroll();
            }
        }); 

        this.slides = Observable.create(observer => {
            let result = Array.from(this.content);
            observer.next(result);
            observer.complete();
        });
        if( this.tags ){
          this.searchType = "TAGS";
          const sTerm = (this.tagresults['meta'] && this.tagresults['meta']['title']) ? " - " + this.tagresults['meta']['title'] : "";
          this.title = this.titleCase("Tag" + sTerm);
          this.metaService.setDynamicSearchTitle(this.title, "TagSearch");
          this.showAll = true;
          this.results = Observable.of(this.tagresults);
          this.cd.detectChanges()
        }

        if( this.route.snapshot.queryParams.q && !this.tags ){
            this.qSearchTerm = this.route.snapshot.queryParams.q;
            this.search(this.route.snapshot.queryParams.q);

            //this.terms.next( this.route.snapshot.queryParams.q );
        } 

        
    }

    ngOnChanges(changes){
    }
    ngOnDestroy(){
        this.coreEffects.removeSearchData();
        if( this.subscription){
            this.subscription.unsubscribe();
        }
        if( this.terms ){
            this.terms.unsubscribe();
        }
//         if (this.coreEffects.getFilterParkedRowSubscription){
//             this.coreEffects.getFilterParkedRowSubscription.unsubscribe();
//         }
// 
//         if (this.coreEffects.firstRowSubscription){
//             this.coreEffects.firstRowSubscription.unsubscribe();
//         }
// 
//         if (this.coreEffects.searchSubscription){
//             this.coreEffects.searchSubscription.unsubscribe();
//         }
        //firstRowSubscription
    }
    private search(term: string): void {
        let newPath = '/' + this.route.snapshot.url[0].path + "?q=" +  term;
        if (!this.isServer){
            history.replaceState( null, null, newPath);
        }
        this.filters = {};
        this.showAll = true;
        this.terms.next(term);
    }
    private needsSearchBox():boolean{
        return this.meta && this.meta.metaFlags ? this.meta.metaFlags.needsSearchBox : false;
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/search/search-component/search.component.ts